import { hasUrlParam, setUrlParam } from 'wsm-srp-utilities';
import { MOBILE, DESKTOP } from '../global-constants';

/**
 * Matches the Akamai origins (`pictures.dealer.com`, `pictures-np.dealer.com`) and the CloudFront
 * pictures-proxy aliases (`pictures.web.dealer.com`, `pictures-np.web-np.dealer.com`).
 * duplicate of `isDealerImage` from wsm-common-data
 */
const DEALER_IMAGE_HOST_REGEX =
	/(?:^|\/\/)(pictures|images|static)(-np)?\.([a-z0-9-]+\.)*dealer\.com(?=[/:?#]|$)/;

export const isDealerDotComImage = (uri) => DEALER_IMAGE_HOST_REGEX.test(uri);
// default widths
const DEFAULT_IMAGE_WIDTH_DESKTOP = 1024;
const DEFAULT_IMAGE_WIDTH_MOBILE = 414;

const defaultWidth = new Map([
	[DESKTOP, DEFAULT_IMAGE_WIDTH_DESKTOP],
	[MOBILE, DEFAULT_IMAGE_WIDTH_MOBILE]
]);

/**
 * Determines if Akamai Image Manager resize parameters should be added to an input Image URL.
 * Returns a string of the input URL with image resize parameters added.
 * @param {string} url - A URL string value
 */

const imageResizer = (uri, deviceType, flagRemoveResizer) => {
	if (!uri || !isDealerDotComImage(uri) || flagRemoveResizer) {
		return uri;
	}

	const IMAGE_WIDTH = defaultWidth.get(deviceType);

	const imageUrl = isDealerDotComImage(uri)
		? setUrlParam(uri, 'impolicy=downsize_bkpt&imdensity=1')
		: uri;

	let src = imageUrl;

	const isOptimized =
		hasUrlParam(imageUrl, 'impolicy') && !hasUrlParam(uri, 'impolicy');

	if (isOptimized) {
		src = setUrlParam(imageUrl, `w=${IMAGE_WIDTH}`);
	}

	return src;
};

export default imageResizer;
